export default __webpack_public_path__ + "static/media/features7.b26e2bec.jpg";